const encoder = new TextEncoder();

function hex(bytes: Uint8Array): string {
  return [...bytes].map(value => value.toString(16).padStart(2, "0")).join("");
}

export async function sha256(value: string): Promise<string> {
  const digest = await crypto.subtle.digest("SHA-256", encoder.encode(value));
  return hex(new Uint8Array(digest));
}

export async function hmacSha256(key: string, message: string): Promise<Uint8Array> {
  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    encoder.encode(key),
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"]
  );
  return new Uint8Array(await crypto.subtle.sign("HMAC", cryptoKey, encoder.encode(message)));
}

export function equalNumbers(left: readonly number[], right: readonly number[]): boolean {
  return left.length === right.length && left.every((value, index) => value === right[index]);
}

export type VerificationCheck = {
  key: "commitment" | "outcome" | "payout";
  ok: boolean;
  expected: unknown;
  actual: unknown;
};

export type VerificationResult<T> = {
  ok: boolean;
  checks: VerificationCheck[];
  calculated: T;
};

export function result<T>(calculated: T, checks: VerificationCheck[]): VerificationResult<T> {
  return { ok: checks.every(check => check.ok), checks, calculated };
}

